export default {"src":"/_next/static/media/giphy.0dfc13bd.gif","height":100,"width":100,"blurWidth":0,"blurHeight":0};